import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container';
import { getLicenseType } from '../../services/service'
import dateFnsFormat from 'date-fns/format';
import { parseDurationVerbose } from '../../services/utils';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Typography } from '@mui/material';



export default function LicenseModelDetail() {
    const params = useParams()
    const [licenseData, setLicenseData] = useState({})
    const [notFound, setNotFound] = useState(false)

    const licenseTypeMap = {
        historian: "Historian",
        pid: "PID",
        anomaly: "Anomaly",
        forecast: "Forecast",
    }

    const licenseTypeParser = (types) => {
        var verboseNameArray = types.map(el => licenseTypeMap[el])
        var verboseTypes = ""
        if (verboseNameArray.length === 3) {
            verboseTypes = verboseNameArray.join(" & ")
        } else if (verboseNameArray.length >= 4) {
            var arr1 = verboseNameArray.slice(0, 3).join(", ")
            var arr2 = verboseNameArray.slice(-1)
            verboseTypes = [arr1, arr2].join(" & ")
        } else {
            verboseTypes = verboseNameArray[0]
        }
        return verboseTypes
    }

    useEffect(() => {
        getLicenseType(params.id).then(async (response) => {
            response.data["duration_verbose"] = parseDurationVerbose(response.data.duration)
            response.data["created_at"] = dateFnsFormat(new Date(response.data.created_at), 'MMMM d, yyyy - HH:mm')
            setLicenseData(response.data)
        }).catch((err) => {
            console.log(err)
            if (err.response.status === 404) {
                setNotFound(true)
            }
        })
    }, [])

    const CardLicense = (props) => {
        const { title, content, description } = props;
        const contentAsText = !!description ? "body1" : "h5"
        return (
            <Card sx={{ display: 'flex', backgroundColor: "#E7EBF0", boxShadow: "0 8px 20px -12px rgba(0,0,0,0.3)", }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography variant="subtitle1" color="text.secondary" component="div">
                            {title}
                        </Typography>
                        <Typography component="div" variant={contentAsText} sx={{ whiteSpace: 'pre-line' }}>
                            {content}
                        </Typography>
                    </CardContent>
                </Box>
            </Card>
        )
    }

    return (
        !!notFound
            ? (
                <Typography variant={"h4"}>
                    {"Not Found"}
                </Typography>
            )
            : !licenseData.name
                ? null
                : (
                    <Container>
                        <Row style={{ padding: "20px" }}>
                            <Typography align="center" component="div" variant="h4">
                                Informações sobre o Modelo de Licença <strong>{licenseData.name}</strong>
                            </Typography>
                        </Row>
                        <Row>
                            <Col lg={6}>
                                <CardLicense
                                    title={"Tipo de Licença"}
                                    content={licenseTypeParser(licenseData.types)}
                                />
                            </Col>
                            <Col lg={6}>
                                <CardLicense
                                    title={"Duração"}
                                    content={licenseData.duration_verbose}
                                />
                            </Col>
                        </Row>
                        {
                            !!licenseData.config
                                ? <> 
                                <Row style={{ padding: "20px 0px 20px 0px" }}>
                                    <Col lg={6}>
                                        <CardLicense
                                            title={"Máximo de Tags"}
                                            content={
                                                !licenseData.config.historian
                                                    ? "N/A"
                                                    : !!licenseData.config.historian.max_tags
                                                        ? licenseData.config.historian.max_tags
                                                        : "∞"

                                            }
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <CardLicense
                                            title={"Máximo de Malhas de Controle"}
                                            content={
                                                !licenseData.config.pid
                                                    ? "N/A"
                                                    : !!licenseData.config.pid.max_control_loops
                                                        ? licenseData.config.pid.max_control_loops
                                                        : "∞"

                                            }
                                        />
                                    </Col>
                                    
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <CardLicense
                                            title={"Máximo Anomalias"}
                                            content={
                                                !licenseData.config.anomaly
                                                    ? "N/A"
                                                    : !!licenseData.config.anomaly.max_anomalies
                                                        ? licenseData.config.anomaly.max_anomalies
                                                        : "∞"

                                            }
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <CardLicense
                                            title={"Máximo Forecasts"}
                                            content={
                                                !licenseData.config.forecast
                                                    ? "N/A"
                                                    : !!licenseData.config.forecast.max_forecasts
                                                        ? licenseData.config.forecast.max_forecasts
                                                        : "∞"

                                            }
                                        />
                                    </Col>
                                </Row>
                            </>                                
                                : null
                        }
                        <Row style={{ padding: "20px 0px 20px 0px" }}>
                            <Col lg={12}>
                                <CardLicense
                                    title={"Descrição do Modelo de Licença"}
                                    content={licenseData.description}
                                    description={true}
                                />
                            </Col>
                        </Row>
                    </Container>
                )
    )
}